export enum InventoryEventTabs {
  Info = 'info',
  Tags = 'tags',
  SellThroughRate = 'sellThroughRate',
  ManualPricing = 'manualPricing',
  Transactions = 'transactions',
  Fulfillment = 'fulfillment',
  FulfillmentRules = 'fulfillmentRules',
  Dashboard = 'dashboard',
  EditMap = 'editMap',
  PricingABTest = 'pricingABTest',
  None = 'none',

  // Mobile tabs
  Mobile_Sales = 'mobileSales',
  Mobile_Purchases = 'mobilePurchases',
  Mobile_Notes = 'mobileNotes',
}
